function sn_initialize() {
    runCampaigns();
}

function sn_setAnalytics(n) {}

function sn_mobile_check() {
    var n = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        n
    ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            n.substr(0, 4)
        )
        ? !0
        : !1;
}

function sn_loadTest(n) {
    (sn_value = sn_getCookieValue(n.sn_id, "variation_id")),
        n.sn_variations_letters.indexOf(sn_value) > -1
            ? sn_loadVariation(n.sn_variations_letters.indexOf(sn_value) + 1, n)
            : sn_loadVariation(sn_randomVariation(n), n);
}

function sn_sendAnalytics(n, i, t) {}

function sn_randomVariation(n) {
    var t = 2147483647,
        e = Math.random() * t,
        a = [0];
    for (i = 1; i <= n.sn_variations_count; i++)
        if (
            ((a[i] = a[i - 1] + t * (n.sn_traffic_allocate[i - 1] / 100)),
            e >= a[i - 1] && e < a[i])
        )
            return i;
}

function sn_loadVariation(n, i) {
    (notification = i.sn_variations_letters[n - 1]),
        sn_setCookie(i.sn_id, notification),
        (notif = i["variation" + notification]),
        "undefined" != typeof notif.notif_text &&
            sn_showNotification(
                notification,
                notif.notif_fa,
                notif.notif_text,
                i.notif_theme,
                i.notif_pos_class,
                i.sn_animation_class
            ),
        sn_sendAnalytics(
            "Smart Notifications",
            i.sn_id + ": " + notification,
            notif.sn_event_text
        );
}

function sn_setCookie(n, i) {
    var t = "variation_id=" + i,
        e = new Date();
    e.setTime(e.getTime() + 5184e6);
    var a = "expires=" + e.toUTCString(),
        o = "path=/";
    document.cookie = n + "=" + t + ";" + a + ";" + o;
}

function sn_getCookieValue(n, i) {
    var t = sn_readCookie(n).split(/=|&/);
    return t[t.indexOf(i) + 1];
}

function sn_readCookie(n) {
    for (
        var i = n + "=", t = document.cookie.split(";"), e = 0;
        e < t.length;
        e++
    ) {
        for (var a = t[e]; " " == a.charAt(0); ) a = a.substring(1);
        if (0 === a.indexOf(i)) return a.substring(i.length, a.length);
    }
    return "";
}

function sn_addStyleAndHTML(n, i) {
    var t = n + i,
        e = document.createElement("style");
    e.appendChild(document.createTextNode(t)),
        document.getElementsByTagName("head")[0].appendChild(e);
}

function sn_showNotification(n, i, t, e, a, o) {
    if (document.body.classList.contains("otirosite")) {
        window.setTimeout(function () {
            var s = document.createElement("div");

            s.setAttribute(
                "class",
                "animated sn-container " + e + " " + a + " " + o
            ),
                s.setAttribute("style", "position:fixed"),
                (s.innerHTML =
                    '<div class="sn-notif sn-notif-' +
                    n +
                    '"><div class="sn-content sn-front"><i class="fa fa-' +
                    i +
                    ' sn-icon"></i><p>' +
                    t +
                    '</p><span class="fa fa-times-circle sn-close"></span><span class="fa fa-info-circle sn-info"></span></div></div>'),
                document.body.insertBefore(s, document.body.childNodes[0]),
                document.getElementsByClassName("sn-close")[0].addEventListener(
                    "click",
                    function () {
                        document.getElementsByClassName(
                            "sn-container"
                        )[0].style.display = "none";
                    },
                    !1
                );
            var r = document.getElementsByClassName("sn-container")[0];
            delayFadeOut(r, o);
        }, 3e3);
    } else {
        var $deliveryTimeWrapper = document.querySelector(".cart-delivery");

        if (
            $deliveryTimeWrapper === null ||
            $deliveryTimeWrapper.classList.contains("multiple-products-in-cart")
        )
            return;

        window.setTimeout(function () {
            var s = document.createElement("div");

            var deliveryPopoverText =
                $deliveryTimeWrapper.getAttribute("data-popover-text");

            s.setAttribute(
                "class",
                "animated sn-container " + e + " " + a + " " + o
            ),
                s.setAttribute("style", "position:fixed"),
                (s.innerHTML =
                    '<div class="sn-notif sn-notif-' +
                    n +
                    '"><div class="sn-content sn-front"><svg preserveAspectRatio="none" viewBox="0 0 25.6 15.7" id="delivery-truck" xmlns="http://www.w3.org/2000/svg"><path d="M8 11.203a2.248 2.248 0 1 0 2.249 2.248A2.248 2.248 0 0 0 8 11.203zm0 3.2a.976.976 0 1 1 .977-.976.976.976 0 0 1-.977.976zm11.865-3.2a2.248 2.248 0 1 0 2.248 2.248 2.248 2.248 0 0 0-2.248-2.248zm0 3.2l-.04.001a.976.976 0 1 1 .976-.976v.015a.976.976 0 0 1-.934.96zm-9.336-10.12a.576.576 0 0 1-.576.576H2.048a.576.576 0 0 1-.576-.576v-.344a.576.576 0 0 1 .576-.576h7.905a.576.576 0 0 1 .576.576z" /><path d="M24.273 7.635c-.8-.216-1.296-.352-1.6-.976l-1.072-2.184a2.325 2.325 0 0 0-1.865-1.136h-1.527a.192.192 0 0 1-.192-.192V1.298c.003-.032.005-.068.005-.106A1.192 1.192 0 0 0 16.83 0c-.027 0-.054 0-.08.002H4.68c-1.224 0-1.808.584-1.808 1.296v1.16a.336.336 0 0 0 .328.337h6.753a1.144 1.144 0 0 1 1.144 1.144v.344a1.144 1.144 0 0 1-1.144 1.144H3.202l-.025-.001a.304.304 0 0 0-.304.304v.426c0 .312.433.312.433.312H7.85a1.144 1.144 0 0 1 1.144 1.144v.344A1.144 1.144 0 0 1 7.85 9.1H3.378s-.504 0-.504.392v2.784l-.001.032a1.296 1.296 0 0 0 1.296 1.296h.713c.16 0 .184-.088.184-.136a2.932 2.932 0 0 1 5.864 0c0 .048 0 .136.112.136h5.76c.113 0 .113-.096.113-.136a2.932 2.932 0 0 1 5.864 0c0 .048 0 .136.072.136h1.472a1.289 1.289 0 0 0 1.28-1.28v-2.4c0-2.104-.648-2.104-1.328-2.288zm-2.4-.112h-3.69a.169.169 0 0 1-.166-.143V4.339s0-.12.184-.12h1.04a2.064 2.064 0 0 1 1.659.998l.004.01.96 1.976a1.426 1.426 0 0 0 .132.212l-.003-.004c.04.032-.016.112-.16.112z" /><path d="M8.425 7.963a.576.576 0 0 1-.576.576H.576A.576.576 0 0 1 0 7.963v-.344a.576.576 0 0 1 .576-.576h7.28a.576.576 0 0 1 .576.576z" /></svg><p>' +
                    deliveryPopoverText +
                    '</p><span class="fa fa-times-circle sn-close"></span><span class="fa fa-info-circle sn-info"></span></div></div>'),
                document.body.insertBefore(s, document.body.childNodes[0]),
                document.getElementsByClassName("sn-close")[0].addEventListener(
                    "click",
                    function () {
                        document.getElementsByClassName(
                            "sn-container"
                        )[0].style.display = "none";
                    },
                    !1
                );
            var r = document.getElementsByClassName("sn-container")[0];
            delayFadeOut(r, o);
        }, 3e3);
    }
}

function delayFadeOut(n, i) {
    window.setTimeout(function () {
        n.classList.remove(i), n.classList.add("fadeOut");
    }, 1e4);
}

function runCampaigns() {
    for (var n in sn_campaigns) {
        campaign = sn_campaigns[n];
        var i = !1;
        campaign.sn_check_for_regex
            ? campaign.sn_regex_check() && (i = !0)
            : (i = !0),
            i &&
                ((campaign.sn_animation_class =
                    "slide-in" == campaign.notif_animation
                        ? "bottom" === campaign.notif_pos_vertical
                            ? "slideInUp"
                            : "slideInDown"
                        : "bottom" === campaign.notif_pos_vertical
                        ? "fadeIn"
                        : "fadeIn"),
                sn_addStyleAndHTML(sn_stylesheet, campaign.sn_custom_css),
                sn_setAnalytics(sn_ga_id),
                sn_mobile_check() === !0
                    ? (0 == campaign.sn_device ||
                          4 == campaign.sn_device ||
                          5 == campaign.sn_device ||
                          6 == campaign.sn_device) &&
                      sn_loadTest(campaign)
                    : (null != navigator.userAgent.match(/iPad/i)) == !0 ||
                      /(android)/i.test(navigator.userAgent) === !0
                    ? (0 == campaign.sn_device ||
                          2 == campaign.sn_device ||
                          3 == campaign.sn_device ||
                          6 == campaign.sn_device) &&
                      sn_loadTest(campaign)
                    : (0 == campaign.sn_device ||
                          1 == campaign.sn_device ||
                          3 == campaign.sn_device ||
                          5 == campaign.sn_device) &&
                      sn_loadTest(campaign));
    }
}

function sn_isGALoaded() {
    return (
        (sn_ga = window[window.GoogleAnalyticsObject || "ga"]),
        "function" == typeof sn_ga ? !0 : !1
    );
}
(sn_campaigns = new Array()),
    (sn_stylesheet =
        '.sn-container { display:inline-block; -webkit-perspective: 800; margin: 0px; padding: 0px; z-index:2147483647; width: 255px;float:left;background:none;border:none; border-radius:3px; box-shadow: 0px 1px 5px rgba(0,0,0, 0.2); -webkit-box-shadow: 0px 1px 5px rgba(0,0,0, 0.2); -moz-box-shadow: 0px 1px 5px rgba(0,0,0, 0.2);} .sn-container .sn-notif.flipped { -webkit-transform: rotatex(-180deg); } .sn-container .sn-notif { float:left; width: 255px;background:#fff; -webkit-transform-style: preserve-3d; -webkit-transition: 0.5s; border-radius: 3px; -moz-border-radius: 3px; -webkit-border-radius: 3px; border: 1px solid #cacaca; color:#333!important; min-height:75px; } .sn-container .sn-notif .sn-content { table-layout:fixed; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; position: relative;width:253px;min-height:75px; height:initial; padding:10px; -webkit-backface-visibility: hidden; z-index: 2; font-family: "Open Sans", sans-serif; line-height: 1.2em; color: #333; display:table;} .sn-container .sn-notif .sn-content p { width:195px; white-space: pre-wrap; word-break: inherit; word-wrap: break-word; padding-left:30px; margin: 0px; font-size: 12px; height: inherit; display: table-cell; vertical-align: middle;} .sn-container .sn-notif .sn-front {  } .sn-container .sn-notif .sn-back { -webkit-transform: rotatex(-180deg); cursor: pointer; background:#df3f75; color:#fff; } .sn-container .sn-notif .sn-back p { text-align:center; } .sn-container i.fa { font-size: 35px; float: left; padding-right: 0px; min-width: 40px; text-align: center; padding-top: 10px; } .sn-container .sn-close { color: #fff; position: absolute; top: 5px; right: 5px; cursor: pointer; font-size: 16px; width: 25px; height: 25px; text-align: right; } .sn-container:hover .sn-close { color: #999; } .sn-container:hover .sn-notif.flipped .sn-close { color: #fff;} .sn-container .sn-notif.flipped .sn-close { color: #df3f75; } .sn-back a, .sn-back a:visited, .sn-back a:hover { color:#fff; font-weight:bold;} .sn-icon { color:#3acd7b; } .sn-icon-flipped { color:#fff!important; } .sn-container .sn-info { display:none;color: #999;font-size:11px; position: absolute; bottom: 5px; right: 6px; cursor: pointer; } .sn-container .sn-notif.flipped { color:#fff; border: 1px solid #c33364;} .sn-container .sn-notif.flipped .sn-info { color:#fff; } .sn-container .sn-notif.flipped i.fa { color:#fff; } .sn-container.top-left { left:50px;top:50px; } .sn-container.top-right { right:50px;top:50px; } .sn-container.bottom-left { left:50px;bottom:50px; } .sn-container.bottom-right { right:50px;bottom:50px; } .sn-container .sn-notif .sn-back.sn-hidden{display:none;} .sn-container.dark .sn-notif { background:#333; border:1px solid #222; } .sn-container.dark .sn-notif .sn-content { color:#fff; } .sn-container.dark .sn-icon { color:#fff; } .sn-container.light .sn-notif { background:#fff; border:1px solid #cacaca; } .sn-container.light .sn-notif .sn-content { color:#333; } .sn-container.light .sn-icon { color:#3acd7b; } .sn-container:hover { box-shadow: 0px 1px 5px rgba(0,0,0, 0.3);-webkit-box-shadow: 0px 1px 5px rgba(0,0,0, 0.3);-moz-box-shadow: 0px 1px 5px rgba(0,0,0, 0.3);} @charset "UTF-8"; .animated { -webkit-animation-duration: 1s; animation-duration: 1s; -webkit-animation-fill-mode: both; animation-fill-mode: both; } .sn_hidden{ display:none; } @-webkit-keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } } @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } } .fadeIn { -webkit-animation-name: fadeIn; animation-name: fadeIn; } @-webkit-keyframes fadeOut { from { opacity: 1; z-index: 2147483647; } to { opacity: 0; z-index: -200; } } @keyframes fadeOut { from { opacity: 1; z-index: 2147483647; } to { opacity: 0; z-index:-200; } } .fadeOut { -webkit-animation-name: fadeOut; animation-name: fadeOut; } @-webkit-keyframes slideInDown { from { -webkit-transform: translate3d(0, -200px, 0); transform: translate3d(0, -200px, 0); visibility: visible; } to { -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0); } } @keyframes slideInDown { from { -webkit-transform: translate3d(0, -200px, 0); transform: translate3d(0, -200px, 0); visibility: visible; } to { -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0); } } .slideInDown { -webkit-animation-name: slideInDown; animation-name: slideInDown; } @-webkit-keyframes slideInUp { from { -webkit-transform: translate3d(0, 200px, 0); transform: translate3d(0, 200px, 0); visibility: visible; } to { -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0); } } @keyframes slideInUp { from { -webkit-transform: translate3d(0, 200px, 0); transform: translate3d(0, 200px, 0); visibility: visible; } to { -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0); } } .slideInUp { -webkit-animation-name: slideInUp; animation-name: slideInUp; }'),
    (sn_ga_id = "UA-13187197-1");
var campaign123 = new (function () {
    (this.notif_pos_class = "top-right"),
        (this.notif_pos_vertical = "top"),
        (this.notif_theme = "light"),
        (this.notif_animation = "slide-in"),
        (this.sn_id = "SN-123"),
        (this.sn_device = 0),
        (this.sn_variations_count = 2),
        (this.sn_check_for_regex = !0),
        (this.sn_custom_css = ""),
        (this.sn_traffic_allocate = [0.0, 199.1]),
        (this.sn_variations = ["variation732466", "variation248566"]),
        (this.sn_variations_letters = ["732466", "248566"]),
        (this.variation732466 = {
            sn_event_text: "Your website without Smart Notifications",
        }),
        (this.variation248566 = {
            notif_fa: "heart",
            sn_event_text: notifiy.goedkoper,
            notif_text: notifiy.goedkoper,
        }),
        (this.sn_regex_check = function () {
            var n = window.location.href,
                i = new RegExp("(/cart/|/bestellen/$)");
            return true;
        });
})();
sn_campaigns.push(campaign123), (sn_loaded = !1);
var sn_ga;
sn_isGALoaded()
    ? (sn_initialize(), (sn_loaded = !0))
    : (document.addEventListener("DOMContentLoaded", function () {
          sn_initialize(), (sn_loaded = !0);
      }),
      setTimeout(function () {
          (sn_loaded = !1) && sn_initialize();
      }, 3e3));

Number.isInteger =
    Number.isInteger ||
    function (value) {
        return (
            typeof value === "number" &&
            isFinite(value) &&
            Math.floor(value) === value
        );
    };

var canUpdateMontage = false;

setTimeout(function () {
    canUpdateMontage = true;
}, 1000);

function encode64(str) {
    return encode64I(unescape(encodeURIComponent(str)));
}

function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}

var b64array =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function encode64I(input) {
    var base64 = "";
    var chr1,
        chr2,
        chr3 = "";
    var enc1,
        enc2,
        enc3,
        enc4 = "";
    var i = 0;
    do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        base64 =
            base64 +
            b64array.charAt(enc1) +
            b64array.charAt(enc2) +
            b64array.charAt(enc3) +
            b64array.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);
    return base64;
}

function saveMontageOption() {
    if (!canUpdateMontage) return;

    var currentState = Cookies2.get("checkoutData");

    if (currentState !== undefined) {
        try {
            currentState = JSON.parse(b64_to_utf8(currentState));
        } catch (e) {
            try {
                currentState = JSON.parse(currentState);
            } catch (e) {
                currentState = {};
            }
        }
    } else {
        currentState = {};
    }

    var $mOption = $('[name="montageoptie"]:checked');
    var montageLocData = {};

    currentState["montageoptie"] = $('[name="montageoptie"]:checked').val();

    if (currentState.ventiel === null) {
        currentState["ventiel"] = parseInt($('[name="ventiel"]:checked').val());
    }

    var homesearchCookie = "";

    if ($mOption.val() == "zelf") {
        homesearchCookie = "zelf";

        $(document).trigger("ctachange", ["Naar gegevens"]);
        $(".cart-montagenextstep").addClass("hidden");
    } else if ($mOption.val() == "garage" || $mOption.val() == "laten") {
        homesearchCookie = "laten";
        $(document).trigger("ctachange", ["Naar gegevens en montage"]);

        $(".cart-montagenextstep").removeClass("hidden");
    } else if ($mOption.val() == "mobiel") {
        homesearchCookie = "mobiel";
        $(".cart-montagenextstep").removeClass("hidden");
    }

    if (homesearchCookie.length > 0) {
        Cookies2.set("homemontage", homesearchCookie, {
            expires: 365,
            path: "/",
        });
    }
}

function saveUpsells() {
    var upsellData = [];

    $(".upsellCosts:not(.hidden)").each(function () {
        var upsell_id = $(this).attr("data-upsell-id");
        var amount = $(this).find("select").val();

        if (typeof amount == "undefined") {
            amount = $(this).attr("data-amount");
        }
        upsellData.push({ upsell_id: upsell_id, amount: amount });
    });

    var upsells = encode64(JSON.stringify(upsellData));

    Cookies2.set("upsells", upsells, { expires: 31, path: "/" });
}

function monterenChange() {
    $(".montageCosts").addClass("hidden");

    var $montageOptie = $('[name="montageoptie"]:checked').closest(
        ".montageOption"
    );
    $(".montageOption.selected").removeClass("selected");
    $montageOptie.addClass("selected");

    $(".monterenLocatie").addClass("hidden");
    $(".postcodeInput").addClass("hidden");
    $(".huisnummerInput").addClass("hidden");
    $(".postcodeError").addClass("hidden");
    $montageOptie.find(".monterenLocatie").removeClass("hidden");
    $montageOptie.find(".postcodeInput").removeClass("hidden");
    $montageOptie.find(".huisnummerInput").removeClass("hidden");

    $(".noOption").addClass("hidden");

    $("body").attr("montage-option", $('[name="montageoptie"]:checked').val());

    $("body").trigger("montagechange", [
        $('[name="montageoptie"]:checked').val(),
    ]);

    var event = new CustomEvent("montagechange", {
        detail: $('[name="montageoptie"]:checked').val(),
    });
    document.body.dispatchEvent(event);

    $(".montageWijzigenText > span").hide();
    $(
        '.montageWijzigenText > span[class="mp-' +
            $('[name="montageoptie"]:checked').val() +
            '"]'
    ).show();

    saveMontageOption();
    calcCartPrice();
}

function calcIn3Price() {
    var cartTotal = $("#runningtotal").attr("data-calculated-total");
    var in3Amount = Math.floor((cartTotal / 3) * 100) / 100;

    $(".in3-placeholder").text(
        new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "EUR",
        }).format(in3Amount)
    );
}

function calcCartPrice() {
    if (typeof $(".totalArea").data("total") == "undefined") {
        var basePrice = parseFloat($(".totalPrice").attr("data-total"));

        $(".upsellpageupsell.upsellCosts:not(.hidden)").each(function () {
            var upsellPrice = parseFloat($(this).attr("data-total"));

            basePrice += upsellPrice;
        });

        var verzendPrice = parseFloat($(".verzendingRow").attr("data-total"));

        basePrice += verzendPrice;

        $(".totalPrice .totaalprijs").text(
            new Intl.NumberFormat("nl-NL", {
                style: "currency",
                currency: "EUR",
            }).format(basePrice)
        );
    } else {
        var basePrice = parseFloat($(".totalArea").attr("data-total"));
        var ventiel = $('[name="ventiel"]:checked').val();
        var montageCosts = parseFloat(
            $('[name="montageoptie"]:checked')
                .closest(".montageOption")
                .attr("data-total")
        );

        if (ventiel == 1) {
            var ventielenPrice = parseFloat(
                $(".ventielenCosts").attr("data-total")
            );

            basePrice += ventielenPrice;
        }

        if (
            typeof montageCosts !== "undefined" &&
            montageCosts != "" &&
            !isNaN(montageCosts)
        ) {
            basePrice += montageCosts;

            $(".montageCosts").removeClass("hidden");
            $(".montageCosts .col-xs-4").text(
                new Intl.NumberFormat("nl-NL", {
                    style: "currency",
                    currency: "EUR",
                }).format(montageCosts)
            );
        } else {
            $(".montageCosts").addClass("hidden");
        }

        $(".upsellCosts:not(.hidden)").each(function () {
            var upsellPrice = parseFloat($(this).attr("data-total"));

            basePrice += upsellPrice;
        });

        if ($(".cart-montageestimate[data-total]:visible").length > 0) {
            var montageEstimatePrice = parseFloat(
                $(".cart-montageestimate[data-total]:visible").attr(
                    "data-total"
                )
            );

            basePrice += montageEstimatePrice;
        }

        if ($(".cart-mm[data-total]:visible").length > 0) {
            var montageEstimatePrice = parseFloat(
                $(".cart-mm[data-total]:visible").attr("data-total")
            );

            basePrice += montageEstimatePrice;
        }

        var verzendPrice = parseFloat($(".verzendingRow").attr("data-total"));

        basePrice += verzendPrice;

        $("#runningtotal")
            .text(
                new Intl.NumberFormat("nl-NL", {
                    style: "currency",
                    currency: "EUR",
                }).format(basePrice)
            )
            .attr("data-calculated-total", basePrice);

        calcIn3Price();
    }
}

function resetUpsellsAfterBack() {
    var upsellState = Cookies2.get("upsells");

    if (upsellState == "" || typeof upsellState == "undefined") return;

    upsellState = JSON.parse(b64_to_utf8(upsellState));

    $.each(upsellState, function (index, ups) {
        var $li = $('[data-upsell-id="' + ups.upsell_id + '"]');

        $li.addClass("autorestore");
        $li.find('[name="quantity"]').each(function () {
            $(this).val(ups.amount);
        });

        $li.find("button").addClass("autoclick").trigger("markclick");
    });
}

(function ($) {
    if ($("#cartOrderTopBtn").length > 0) {
        document.getElementById("cartOrderTopBtn").onclick = function (event) {
            event.preventDefault();
            saveVentielStatus();
            $("#cartForm").trigger("submit");
        };
    }

    $(document).on("click", "#mountingChoiceModal label", function () {
        $("#mountingChoiceModal").attr(
            "data-selected-method",
            $(this).find("input").val()
        );
    });

    function setMontageMethod(montageMethode) {
        Cookies2.set("homemontage", montageMethode, {
            expires: 365,
            path: "/",
        });
    }

    function openMontagePopup(triggerAction = false) {
        $("#mountingChoiceModal").attr("data-close-action", triggerAction);

        var currentMontageMethod = $("body").attr("montage-option");

        if (
            typeof currentMontageMethod != "undefined" &&
            currentMontageMethod != ""
        ) {
            if (currentMontageMethod == "garage") {
                currentMontageMethod = "laten";
            }

            $(
                '#mountingChoiceModal input[name="montagemethode"][value="' +
                    currentMontageMethod +
                    '"]'
            ).prop("checked", true);

            $("#mountingChoiceModal .error").addClass("hidden");

            $("#mountingChoiceModal").attr(
                "data-selected-method",
                currentMontageMethod
            );
        }
        $("#mountingChoiceModal").modal();

        $(document).on(
            "click",
            "#mountingChoiceModal .montage-push-area label",
            function (e) {
                $("#mountingChoiceModal .error").addClass("hidden");
            }
        );

        $(document).on(
            "click",
            "#mountingConfirmationModal [data-select-montage]",
            function () {
                Cookies2.set("mountingconfirm", "1", {
                    expires: 365,
                    path: "/",
                });
            }
        );

        $(document).on(
            "click",
            "#mountingChoiceModal [data-select-montage], #mountingConfirmationModal [data-select-montage], #mountingChoiceModal .btn-wrapper button",
            function (e) {
                e.preventDefault();

                var selectedMethod = $("#mountingChoiceModal").attr(
                    "data-selected-method"
                );

                if (typeof $(this).attr("data-select-montage") != "undefined") {
                    selectedMethod = $(this).attr("data-select-montage");
                }

                if (
                    typeof selectedMethod == "undefined" ||
                    selectedMethod.trim().length === 0
                ) {
                    $("#mountingChoiceModal .error.hidden").removeClass(
                        "hidden"
                    );
                    return;
                } else {
                    $("#mountingChoiceModal .error").addClass("hidden");
                }

                $("#mountingChoiceModal").modal("hide");

                if (
                    $("#mountingConfirmationModal:not(.in)").length > 0 &&
                    selectedMethod == "zelf" &&
                    Cookies2.get("mountingconfirm") != "1"
                ) {
                    $("#mountingConfirmationModal").modal();
                    $("#singlePieceModal h4").text("Echt maar 1 band nodig?");

                    return;
                } else if ($("#mountingConfirmationModal.in").length > 0) {
                    $("#mountingConfirmationModal").modal("hide");
                }

                setMontageMethod(selectedMethod);

                if (
                    $("#mountingChoiceModal").attr("data-close-action") ==
                    "edit"
                ) {
                    window.location.reload(true);
                } else {
                    redirectToCheckout(selectedMethod);
                }
            }
        );
    }

    function getSelectedMontageMethod() {
        var montageMethod = Cookies2.get("homemontage") || "";

        if (montageMethod == "undefined") {
            montageMethod = "";
        }

        return montageMethod;
    }

    function redirectToCheckout(selectedMethod = false) {
        var useMontageMethod = selectedMethod;

        if (useMontageMethod === false) {
            useMontageMethod = getSelectedMontageMethod();
        }

        var $cartForm = $("#cartForm");
        var redirectURL = $cartForm.attr("data-checkout-zelf");

        if (useMontageMethod === "laten") {
            redirectURL = $cartForm.attr("data-checkout-mp");
        }

        window.location = redirectURL;
    }

    function cartSubmit() {
        var validVentiel = false;
        console.log(typeof checkForValveInput);
        if (typeof checkForValveInput != "undefined") {
            validVentiel = checkForValveInput();
        }

        if ($("#monterenOptions:visible").length > 0) {
            saveMontageOption();

            $(".noOption").addClass("hidden");

            var validMontage = true;

            var montageOptie = $('[name="montageoptie"]:checked').val();
            var montageUrl = $('[name="montageoptie"]:checked')
                .closest(".montageOption")
                .attr("data-checkout-url");

            if (montageUrl == "" || typeof montageUrl == "undefined") {
                montageUrl = "";

                validMontage = false;

                $(".noOption").removeClass("hidden");

                if (
                    $("#ventielenOptions:visible").length === 0 ||
                    (ventiel != "" && typeof ventiel !== "undefined")
                ) {
                    $("html, body").animate(
                        {
                            scrollTop: $(".noOption").offset().top - 100,
                        },
                        800
                    );
                }
            }

            var $mOption = $('[name="montageoptie"]:checked').closest(
                ".montageOption"
            );
            $(".postcodeError").addClass("hidden");

            if (montageUrl != "") {
                if (validVentiel) {
                    if (
                        $("#ventielenModal #ventielenOptions:not(:visible)")
                            .length === 1 &&
                        typeof $('[name="ventiel"]:checked').val() ==
                            "undefined"
                    ) {
                        $("#ventielenModal").modal();
                    } else {
                        $(".nextPageLoaderBtn").removeClass("hidden");
                        window.location = montageUrl;
                    }
                }
            }
        } else {
            if (document.body.getAttribute("data-cta-popup") === "montage") {
                var selectedMontageMethod = getSelectedMontageMethod();
                if (selectedMontageMethod == "") {
                    openMontagePopup();
                } else {
                    // redirect
                    redirectToCheckout();
                }
            } else {
                if (!validVentiel) {
                    redirectToCheckout();
                    return;
                }
                if (
                    $("#ventielenModal #ventielenOptions:not(:visible)")
                        .length === 1 &&
                    typeof $('[name="ventiel"]:checked').val() == "undefined" &&
                    $("#ventielenModal").length > 0
                ) {
                    $("#ventielenModal").modal();
                } else {
                    $(".nextPageLoaderBtn").removeClass("hidden");
                    window.location = $("#cartForm").attr("action");
                }
            }
        }
    }

    $(document).on("submit", "#cartForm", function (e) {
        e.preventDefault();

        if ($(".mfPreventCheckout").length > 0) {
            return false;
        }

        cartSubmit();
    });

    $("#ventielenModal").on("shown.bs.modal", function () {
        if (typeof gtag != "undefined") {
            var valvePrice = parseFloat(
                $(".ventielenCosts").attr("data-pc-price")
            );

            gtag("event", "view_item", {
                currency: "EUR",
                value: valvePrice,
                items: [
                    {
                        item_id: "product_2",
                        item_name: "Ventiel",
                        index: 0,
                        item_brand: "BetterTires",
                        price: valvePrice,
                    },
                ],
            });
        }

        if ($('[name="ventiel"]:checked').length > 0) {
            $("#ventielenSubmit").removeClass("no-selection");
        } else {
            $("#ventielenSubmit").addClass("has-selection");
        }
    });

    $(document).on("click", "#ventielenOptions input", function () {
        setTimeout(() => {
            var eventName =
                $('[name="ventiel"]:checked').val() == "1"
                    ? "add_to_cart"
                    : "remove_from_cart";

            if (typeof gtag != "undefined") {
                var valvePrice = parseFloat(
                    $(".ventielenCosts").attr("data-pc-price")
                );
                var valvesPrice = parseFloat(
                    $(".ventielenCosts").attr("data-total")
                );

                gtag("event", eventName, {
                    currency: "EUR",
                    value: valvesPrice,
                    items: [
                        {
                            item_id: "product_2",
                            item_name: "Ventiel",
                            index: 0,
                            item_brand: "BetterTires",
                            price: valvePrice,
                            quantity: Math.round(valvesPrice / valvePrice),
                        },
                    ],
                });
            }
        }, 100);
    });
    $(document).on("click", "#ventielenSubmit", function (e) {
        e.preventDefault();
        cartSubmit();
    });

    $(document).on("change", '[name="montageoptie"]', function () {
        monterenChange();
    });

    $("#monterenOptions .montageOption").on("click", function () {
        $(this)
            .closest(".montageOption")
            .find('[name="montageoptie"]')
            .prop("checked", true)
            .trigger("focusin");

        monterenChange();
    });

    if (
        $('[name="montageoptie"]:checked').val() != "" &&
        $('[name="montageoptie"]:checked').val() !== "undefined"
    ) {
        monterenChange();
    }

    $(document).on(
        "click markclick",
        "#upsellarea:not(.upsellpage) button",
        function () {
            var $li = $(this).closest("li");

            var upsell_id = $li.find('[name="upsell_id"]').val();
            var amount = parseInt($li.find('[name="quantity"]').val());

            var $totalBox = $('div[data-upsell-id="' + upsell_id + '"]');
            var piece_price = parseFloat($totalBox.data("piece"));
            var upsell_title = $totalBox.data("title");

            var upsellTotalPrice = piece_price * amount;

            $totalBox.attr("data-total", upsellTotalPrice);

            $totalBox.find(".upsellamount").val(amount);

            $totalBox.find(".price2.total").html(
                '<span class="visible-xs-block">Totaalbedrag</span>' +
                    new Intl.NumberFormat("nl-NL", {
                        style: "currency",
                        currency: "EUR",
                    }).format(upsellTotalPrice)
            );

            if (amount > 0) {
                $totalBox.removeClass("hidden");
            } else {
                $totalBox.addClass("hidden");
            }

            saveUpsells();

            calcCartPrice();
        }
    );

    $(document).on("click", ".deleteUpsell", function (e) {
        e.preventDefault();
        $(this).closest(".upsellCosts").addClass("hidden");
        saveUpsells();
        calcCartPrice();
    });

    $(document).on("change", "select.upsellamount", function () {
        var $cartLine = $(this).closest(".upsellCosts");
        var upsell_id = $cartLine.data("upsell-id");
        var $upsellLine = $('li[data-upsell-id="' + upsell_id + '"]');

        $upsellLine.find('[name="quantity"]').val($(this).val());
        $upsellLine.find("button").trigger("markclick");
    });

    calcCartPrice();

    $(document).on("click", '[data-toggle="tooltip"]', function (e) {
        if ($(window).width() < 1024) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            $("#tooltipModal h4").html($(this).data("tooltip-title"));
            $("#tooltipModal .modal-body").html($(this).data("original-title"));

            $(this).tooltip("hide");

            $("#tooltipModal").modal("show");
        }
    });

    $(document).on("click", ".montageWijzigen a", function (e) {
        e.preventDefault();

        if (
            document.body.getAttribute("data-cta-popup") === "montage" ||
            document.body.getAttribute("data-montage-edit") === "popup"
        ) {
            openMontagePopup("edit");
            return;
        }

        $(".montageWijzigen").hide();
        $("#monterenOptions").show();
    });

    resetUpsellsAfterBack();

    $(document).on("click", "[data-band-url]", function (e) {
        e.preventDefault();

        if ($(window).width() >= 768) {
            window.location = $(this).attr("data-band-url");
        }
    });

    $(document).on("click", "#estimateMontage", function (e) {
        e.preventDefault();

        var test = 1;

        if ($(this).attr("data-test")) {
            test = $(this).attr("data-test");
        }

        $.post(
            $("#cartcontent").attr("data-ajax-url"),
            { action: "estimate_montage", test: test },
            function (data) {
                var usePrice = "error";

                if (data.error !== true) {
                    usePrice = data.average;
                }

                var $wrapper = $(".cart-montageestimate");

                $wrapper.attr("data-total", data.price);

                $wrapper.find("#estimateMontage").remove();
                $wrapper.find(".col-xs-4").html(usePrice);
                $wrapper.find(".col-xs-8 span:not(.estimate-text)").remove();
                $wrapper
                    .find(".col-xs-8")
                    .prepend("<span>Geschatte montagekosten</span>");

                calcCartPrice();
            },
            "JSON"
        );
    });

    function toggleMontageMessage() {
        var montageMethod = $('[name="montageoptie"]:checked').val();

        switch (montageMethod) {
            case "garage":
            case "laten":
            case "mobiel":
                $(".cart-montagenextstep").removeClass("hidden");

                break;

            default:
                $(".cart-montagenextstep").addClass("hidden");
        }
    }

    toggleMontageMessage();

    function deleteProduct(id) {
        var cart = JSON.parse(decodeURIComponent(Cookies2.get("bc_cart")));
        var newCart = {};

        id = parseInt(id);

        $.each(cart, function (productId, cartItem) {
            productId = parseInt(productId);

            if (productId != id) {
                newCart[productId] = cartItem;
            }
        });

        Cookies2.set("bc_cart", encodeURIComponent(JSON.stringify(newCart)), {
            expires: 365,
            path: "/",
        });
    }

    $(document).on("click", ".delete-item-from-cart", function (e) {
        e.preventDefault();

        var sku = this.getAttribute("data-pid");

        if (
            typeof gtag != "undefined" &&
            typeof ga4ProductsJson != "undefined"
        ) {
            var parsed = JSON.parse(ga4ProductsJson);

            var deleteProductData = parsed[sku];

            var eventValue =
                deleteProductData.quantity * deleteProductData.price;

            gtag("event", "remove_from_cart", {
                currency: "EUR",
                value: eventValue,
                items: [deleteProductData],
            });
        }

        deleteProduct($(this).attr("data-id"));

        window.location.reload(true);
    });

    function cartChangeQuantity(productId, count, ventiel) {
        $.post(
            getBCBaseURL() + "/cart-update/",
            {
                product1_s: 1,
                product1_p: productId,
                product1_c: count,
                ventiel: ventiel,
            },
            function (html) {
                window.location.reload();
            }
        );
    }

    $(document).on("click", "#singlepieceUpgrade", function (e) {
        e.preventDefault();

        var productId = $("#singlePieceModal").attr("data-productId");
        $('.cart-amount-changer[data-id="' + productId + '"]').val(2);
        $("#singlePieceModal").modal("hide");

        cartChangeQuantity(
            productId,
            2,
            $("#singlePieceModal").attr("data-ventiel")
        );
    });

    $(document).on("click", "#keepSinglePiece", function (e) {
        e.preventDefault();
        $("#singlePieceModal").modal("hide");

        cartChangeQuantity(
            $("#singlePieceModal").attr("data-productId"),
            1,
            $("#singlePieceModal").attr("data-ventiel")
        );
    });

    $(document).on("change", ".cart-amount-changer", function () {
        var ventiel = $('[name="ventiel"]:checked').val();
        var count = parseInt($(this).val());
        var productId = $(this).attr("data-id");
        var stock = parseInt($(this).attr("data-stock"));

        if (
            count === 1 &&
            stock > 1 &&
            Cookies2.get("singlepiecemodal") != "1"
        ) {
            Cookies2.set("singlepiecemodal", 1);
            $("#singlePieceModal").attr("data-productId", productId);
            $("#singlePieceModal").attr("data-ventiel", ventiel);
            $("#singlePieceModal").modal();
        } else {
            cartChangeQuantity(productId, count, ventiel);
        }
    });

    $(document).on("click", ".alert-mp-rft-remove-tire", function (e) {
        e.preventDefault();
        $('#winkelwagen [data-isrft="1"]').each(function () {
            deleteProduct($(this).attr("data-id"));
        });

        window.location.reload(true);
    });

    $(document).on("click", ".alert-maxinch-remove-tire", function (e) {
        e.preventDefault();

        var inches = $(this).attr("data-inches");

        if (inches.indexOf("|") === -1) {
            inches = new Array(inches);
        } else {
            inches = inches.split("|");
        }

        $.each(inches, function (index, inch) {
            $('#winkelwagen [data-inch="' + inch + '"]').each(function () {
                deleteProduct($(this).attr("data-id"));
            });
        });

        window.location.reload(true);
    });

    $(document).on("click", function () {
        if ($(window).width() > 767) {
            return true;
        }

        if ($(".sn-container").hasClass("slideInDown")) {
            $(".sn-container").remove();
        }
    });

    $(document).on(
        "click",
        ".price-change-warning a[data-chat-params]",
        function (e) {
            e.preventDefault();

            const params = $(this).attr("data-chat-params");
            const $chatBody = $(".tim-popup .chat-body");
            const $iframe = $(".tim-popup iframe");
            let chatURL = $iframe.attr("src");
            let baseURL = chatURL.split("?")[0];
            let newChatURL = baseURL + params;

            $chatBody.html(
                `<iframe src="${newChatURL}" frameborder="0" allowfullscreen=""></iframe>`
            );
            $(".tim-popup").addClass("opened").removeClass("hidden");
        }
    );
})(jQuery);

window.onunload = function () {};
